import {
  FETCH_UPDATE_ROLES_REQUEST,
  FETCH_UPDATE_ROLES_SUCCESS,
  FETCH_UPDATE_ROLES_FALUIRE,
} from './updateRolesTypes'

const initialState = {
  loading: false,
  updateRolesInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_UPDATE_ROLES_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_UPDATE_ROLES_SUCCESS : return {
      ...state,
      updateRolesInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_UPDATE_ROLES_FALUIRE : return {
      ...state,
      loading: false,
      updateRolesInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
